module.exports = __webpack_public_path__ + "static/ap_white-e638b6c9eec0d133532b66b37d2b729d.png";